import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export function KeyForm({ form, setField, keys, onSelectOrOther }) {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
      <div className="space-y-1.5">
        <Label className="text-xs uppercase tracking-wider font-bold text-gray-500">Key Name *</Label>
        <Select value={form.key_name || ""} onValueChange={v => onSelectOrOther("key_name", v, "keys")}>
          <SelectTrigger className="h-11"><SelectValue placeholder="Select key" /></SelectTrigger>
          <SelectContent>
            {keys.map(k => <SelectItem key={k.id} value={k.name}>{k.name}</SelectItem>)}
            <SelectItem value="__other__" className="text-amber-600 font-semibold">Other (not in list)</SelectItem>
          </SelectContent>
        </Select>
      </div>
      <div className="space-y-1.5">
        <Label className="text-xs uppercase tracking-wider font-bold text-gray-500">Issued To *</Label>
        <Input value={form.issued_to || ""} onChange={e => setField("issued_to", e.target.value)} className="h-11" data-testid="field-issued-to" />
      </div>
      <div className="space-y-1.5">
        <Label className="text-xs uppercase tracking-wider font-bold text-gray-500">Department</Label>
        <Input value={form.department || ""} onChange={e => setField("department", e.target.value)} className="h-11" />
      </div>
      <div className="space-y-1.5">
        <Label className="text-xs uppercase tracking-wider font-bold text-gray-500">Purpose</Label>
        <Input value={form.purpose || ""} onChange={e => setField("purpose", e.target.value)} className="h-11" />
      </div>
    </div>
  );
}

export function CourierForm({ form, setField, couriers, onSelectOrOther }) {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
      <div className="col-span-2 space-y-1.5">
        <Label className="text-xs uppercase tracking-wider font-bold text-gray-500">Type (Direction) *</Label>
        <Select value={form.direction || "incoming"} onValueChange={v => setField("direction", v)}>
          <SelectTrigger className="h-11" data-testid="courier-direction"><SelectValue /></SelectTrigger>
          <SelectContent>
            <SelectItem value="incoming">Incoming</SelectItem>
            <SelectItem value="outgoing">Outgoing</SelectItem>
          </SelectContent>
        </Select>
      </div>
      <div className="space-y-1.5">
        <Label className="text-xs uppercase tracking-wider font-bold text-gray-500">Courier Company *</Label>
        <Select value={form.courier_company || ""} onValueChange={v => onSelectOrOther("courier_company", v, "courier_companies")}>
          <SelectTrigger className="h-11"><SelectValue placeholder="Select" /></SelectTrigger>
          <SelectContent>
            {couriers.map(c => <SelectItem key={c.id} value={c.name}>{c.name}</SelectItem>)}
            <SelectItem value="__other__" className="text-amber-600 font-semibold">Other (not in list)</SelectItem>
          </SelectContent>
        </Select>
      </div>
      <div className="space-y-1.5">
        <Label className="text-xs uppercase tracking-wider font-bold text-gray-500">AWB / Tracking No.</Label>
        <Input value={form.awb_no || ""} onChange={e => setField("awb_no", e.target.value)} className="h-11" />
      </div>
      <div className="space-y-1.5">
        <Label className="text-xs uppercase tracking-wider font-bold text-gray-500">{(form.direction || "incoming") === "incoming" ? "From (Sender)" : "Sent To"}</Label>
        <Input value={form.sender || ""} onChange={e => setField("sender", e.target.value)} className="h-11" />
      </div>
      <div className="space-y-1.5">
        <Label className="text-xs uppercase tracking-wider font-bold text-gray-500">{(form.direction || "incoming") === "incoming" ? "To (Recipient)" : "Dispatched By"}</Label>
        <Input value={form.recipient || ""} onChange={e => setField("recipient", e.target.value)} className="h-11" />
      </div>
      <div className="space-y-1.5">
        <Label className="text-xs uppercase tracking-wider font-bold text-gray-500">Department</Label>
        <Input value={form.department || ""} onChange={e => setField("department", e.target.value)} className="h-11" />
      </div>
      <div className="space-y-1.5">
        <Label className="text-xs uppercase tracking-wider font-bold text-gray-500">Description / Contents</Label>
        <Input value={form.description || ""} onChange={e => setField("description", e.target.value)} className="h-11" />
      </div>
      <div className="space-y-1.5">
        <Label className="text-xs uppercase tracking-wider font-bold text-gray-500">No. of Packets</Label>
        <Input type="number" value={form.no_of_packages || ""} onChange={e => setField("no_of_packages", e.target.value)} className="h-11" />
      </div>
      <div className="space-y-1.5">
        <Label className="text-xs uppercase tracking-wider font-bold text-gray-500">Weight</Label>
        <Input value={form.weight || ""} onChange={e => setField("weight", e.target.value)} className="h-11" placeholder="e.g., 2.5 kg" />
      </div>
      <div className="col-span-2 space-y-1.5">
        <Label className="text-xs uppercase tracking-wider font-bold text-gray-500">Remarks</Label>
        <Input value={form.remarks || ""} onChange={e => setField("remarks", e.target.value)} className="h-11" />
      </div>
    </div>
  );
}

export function LogBookForm({ form, setField }) {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
      <div className="col-span-2 space-y-1.5">
        <Label className="text-xs uppercase tracking-wider font-bold text-gray-500">Observation *</Label>
        <Input value={form.observation || ""} onChange={e => setField("observation", e.target.value)} className="h-11" data-testid="field-observation" />
      </div>
      <div className="space-y-1.5">
        <Label className="text-xs uppercase tracking-wider font-bold text-gray-500">Category</Label>
        <Select value={form.category || ""} onValueChange={v => setField("category", v)}>
          <SelectTrigger className="h-11"><SelectValue placeholder="Select" /></SelectTrigger>
          <SelectContent>
            {["General", "Security Incident", "Maintenance", "Safety", "Visitor Issue", "Other"].map(c => (
              <SelectItem key={c} value={c}>{c}</SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
      <div className="space-y-1.5">
        <Label className="text-xs uppercase tracking-wider font-bold text-gray-500">Severity</Label>
        <Select value={form.severity || "low"} onValueChange={v => setField("severity", v)}>
          <SelectTrigger className="h-11"><SelectValue /></SelectTrigger>
          <SelectContent>
            <SelectItem value="low">Low</SelectItem>
            <SelectItem value="medium">Medium</SelectItem>
            <SelectItem value="high">High</SelectItem>
          </SelectContent>
        </Select>
      </div>
      <div className="space-y-1.5">
        <Label className="text-xs uppercase tracking-wider font-bold text-gray-500">Shift</Label>
        <Select value={form.shift || "A"} onValueChange={v => setField("shift", v)}>
          <SelectTrigger className="h-11"><SelectValue /></SelectTrigger>
          <SelectContent>
            <SelectItem value="A">Shift A (08:00 AM - 08:00 PM)</SelectItem>
            <SelectItem value="B">Shift B (08:00 PM - 08:00 AM)</SelectItem>
          </SelectContent>
        </Select>
      </div>
      <div className="col-span-2 space-y-1.5">
        <Label className="text-xs uppercase tracking-wider font-bold text-gray-500">Action Taken</Label>
        <Input value={form.action_taken || ""} onChange={e => setField("action_taken", e.target.value)} className="h-11" />
      </div>
    </div>
  );
}

export function SpecialGateForm({ form, setField }) {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
      <div className="col-span-2 space-y-1.5">
        <Label className="text-xs uppercase tracking-wider font-bold text-gray-500">Description *</Label>
        <Input value={form.description || ""} onChange={e => setField("description", e.target.value)} className="h-11" data-testid="field-description" />
      </div>
      <div className="space-y-1.5">
        <Label className="text-xs uppercase tracking-wider font-bold text-gray-500">Person / Vehicle</Label>
        <Input value={form.person_vehicle || ""} onChange={e => setField("person_vehicle", e.target.value)} className="h-11" />
      </div>
      <div className="space-y-1.5">
        <Label className="text-xs uppercase tracking-wider font-bold text-gray-500">Authorized By</Label>
        <Input value={form.authorized_by || ""} onChange={e => setField("authorized_by", e.target.value)} className="h-11" />
      </div>
      <div className="col-span-2 space-y-1.5">
        <Label className="text-xs uppercase tracking-wider font-bold text-gray-500">Remarks</Label>
        <Input value={form.remarks || ""} onChange={e => setField("remarks", e.target.value)} className="h-11" />
      </div>
    </div>
  );
}
